import { _, $, Backbone, Radio, Foundation } from "../../vendor";
import { IcsBuilder, Notification, Dependencies } from "../utils";
import InboomaBaseController from "./InboomaBaseController";
import Biscuit from "../utils/Biscuit";

import LinksMap from "./ContingentsControllerAccessBarMap";
import Pricetariffs from "../collections/Pricetariffs";
import ContingentPlans from "../collections/ContingentPlans";
import Networks from "../collections/Networks";
import Resource from "../models/Resource";
import Contingent from "../models/Contingent";
import Facility from "../models/Facility";

import ResourcesForm from "../views/contingents/ResourcesForm";
import ContingentsSidebarView from "../views/contingents/ContingentsSidebarView";
import ContingentsSortTabs from "../views/contingents/ContingentsSortTabs";
import ContingentsView from "../views/contingents/ContingentsView";
import OffCanvasContingentsForm from "../views/contingents/OffCanvasContingentsForm";
import LocationsView from "../views/contingents/LocationsView";
import PricetariffForm from "../views/contingents/PricetariffForm";

import PlantoolView from "../views/contingents/PlantoolView";
import FacilitiesView from "../views/facilities/FacilitiesView";
import FacilitiesSidebarView from "../views/facilities/FacilitiesSidebarView";
import FacilitiesSortTabs from "../views/facilities/FacilitiesSortTabs";
import OffCanvasFacilitiesForm from "../views/facilities/OffCanvasFacilitiesForm";
import SlotsForm from "../views/facilities/SlotsForm";

import ContingentsViewTpl from "../templates/contingents/ContingentsTpl.html";
import { isViewVisible, getMaintabViews } from "../utils/ViewSettings";
import { Collection } from "backbone";
import { editContingent } from "inbooma-api/store/contingents/actions";
import { identity } from "underscore";

export default InboomaBaseController.extend({
  _el: "#inb-c-main-contingents",
  _channelName: "contingents",
  _template: ContingentsViewTpl,

  _accessBarMap() {
    return {
      collection: typeof this.collection !== "undefined" ? this.collection : this._collection,
      pageTitle: this.t("contingents", null, "capital"),
      searchPlaceholder:
        this.t("contingent_name") + " / " + this.t("resourcetype", null, "capital"),
      linksMap: LinksMap(),
    };
  },

  _shouldRenderLayout() {
    return $(this._el).length < 1 || $("#calendar").length >= 1 || $("#inb-checkin").length >= 1;
  },

  /**
   * @routes /contingent_plans
   */
  contingentPlans(openForm = false, isNetworkPlan = false) {
    this._resetOptions();

    if (typeof this.dependencies === "undefined") {
      this.dependencies = {
        contingentPlans: new ContingentPlans(),
        networks: new Networks(),
      };
    }

    const that = this;

    new Dependencies(this.dependencies).then(() => {
      const contingentPlans = Radio.channel("contingentPlans").request("get:data");

      that.plantoolView = new PlantoolView({
        collection: contingentPlans,
        isNetworkPlan,
      });

      if (openForm) {
        that.plantoolView.openForm();
      }
    });
  },

  /**
   * @routes /contingent_plans/form
   */
  contingentPlansForm() {
    this.contingentPlans(true);
  },

  /**
   * @routes /network_plans
   */
  networkPlans() {
    this.contingentPlans(false, true);
  },

  /**
   * @routes /network_plans/form
   */
  networkPlansForm() {
    this.contingentPlans(true, true);
  },

  /**
   * @routes /contingents
   *         /contingents:id -> Highlight & toggle contingent
   */
  index(options) {
    if (isViewVisible("contingents", "contingents") !== true) {
      const accessibleViews = getMaintabViews("contingents");
      if (accessibleViews.length > 0)
        Backbone.history.navigate(accessibleViews[0], { trigger: true }); // navigate to next accessible sub menu
      return;
    }

    this._resetOptions(options);

    if ($(".help-link").attr("href") !== "contingents/help" || $("#map").length >= 1) {
      if (typeof this.contingentsView !== "undefined") {
        // Remove any (collection/UI) event listeners of contingentsView
        // as its el === locationsView.el, leading to certain problems
        this.contingentsView.stopListening();
      }

      this.contingentsView = new ContingentsView({
        collection: this._collection,
        widgetMode: this.widgetMode,
        el: this.el,
        toggleId: !isNaN(options) ? Number(options) : null,
      });

      if (!this.widgetMode) {
        this.contingentsSidebarView = new ContingentsSidebarView({
          collection: this._collection,
          model: Contingent,
        });
        this.contingentsSortTabs = new ContingentsSortTabs({
          collection: this._collection,
          model: Contingent,
        });
      }
    }
  },

  resourcesForm(contingentId, action) {
    this.index();

    contingentId = Number(contingentId);

    let model = null,
      contingent = this._collection.get(contingentId);

    if (typeof contingent == "undefined") {
      return;
    }

    if (typeof action == "undefined" || _.isNull(action)) {
      // contingents/:id/resources/add
      model = new Resource({ contingent_id: contingentId });
    } else {
      // contingents/:id/resources/:resourceId
      _.each(contingent.get("resources").models, (resource) => {
        if (resource.get("id") == action) {
          model = resource;
        }
      });

      if (_.isNull(model)) return;
    }

    new ResourcesForm({
      model,
      parent: contingent,
    });
  },

  /**
   * @function duplicateResource
   * Clone a resource, reset it, save it,
   * add it to the collection, route back!
   *
   * Unused as of now :(
   *
   * @param {int} cId contingent_id
   * @param {int} rId resource_id
   */
  duplicateResource(cId, rId) {
    const that = this,
      contingent = this._collection.get(cId);

    if (typeof contingent !== "undefined") {
      const resource = contingent.get("resources").get(rId);

      if (typeof resource !== "undefined") {
        let _resource = new Resource(resource.toJSON());

        delete _resource.attributes.created;
        delete _resource.attributes.created_by;
        delete _resource.attributes.modified;
        delete _resource.attributes.modified_by;

        _resource.save(
          {
            id: "",
            battery_value: "",
          },
          {
            type: "POST",
            success(model, response) {
              contingent.get("resources").add(_resource);

              new Notification({
                message: that.t("duplicate_resource_success_${a}", { a: _resource.get("id") }),
                duration: 5000,
                closeable: true,
                icon: "fi fi-folder-add",
              });

              Backbone.history.navigate("contingents/" + contingent.get("id"), { trigger: true });
            },
            error() {
              new Notification({
                message: that.t("request_error"),
                duration: 5000,
                closeable: true,
                icon: "fi fi-x",
              });

              Backbone.history.navigate("contingents", { trigger: false });
            },
          },
        );
      }
    } else {
      console.log("ALERT: Unknown contingent ID", cId);
    }
  },

  /**
   * @routes /contingents/help
   */
  contingentsHelp() {
    this.index();

    new Foundation.Reveal($(".inb-contingents-help-modal")).open();

    $(document).on("closed.zf.reveal", function () {
      Backbone.history.navigate("contingents");
      $(document).off("closed.zf.reveal");
    });
  },

  /**
   * @routes /contingents/:id[int]/ics
   */
  createIcs(id) {
    const icsBuilder = new IcsBuilder(
      {
        client_id: Number(Biscuit.get("user.client_id")),
        contingent_id: Number(id),
      },
      "inbooma_contingent_" + id,
    );
  },

  editContingent(model, collection) {
    var _coll = collection;
    if (collection === undefined || collection == null) {
      _coll = new Collection();
      _coll.add(model);
    }

    new OffCanvasContingentsForm({
      model,
      collection: _coll,
      afterSave: this.afterContingentSave,
    });
  },

  afterContingentSave(collection, id) {
    const RequestHelper = Backbone.Model.extend({ urlRoot: "/contingents/" + id });

    new RequestHelper().fetch({
      success(model, response) {
        var _model = new Contingent(response.data);
        collection.set(_model, { add: true, merge: true, remove: false });
      },
      error(model, response) {
        console.log("ERROR when fetching contingent");
      },
    });
  },

  /** @routes /contingents/add
   *          /contingents/:id[int]/:action[string]
   */
  contingentsForm(id, action) {
    this.index();

    let model = new Contingent();

    if (id && action == "edit") {
      // contingents/:id/edit
      model = this._collection.get(id);
    }

    if (typeof model !== "undefined") {
      this.editContingent(model, this._collection);
    } else {
      const that = this;
      const RequestHelper = Backbone.Model.extend({ urlRoot: "/contingents/" + id });

      new RequestHelper().fetch({
        success(model, response) {
          var _model = new Contingent(response.data);
          that.editContingent(_model, null);
        },
        error(model, response) {
          console.log("ERROR when fetching contingent");
        },
      });
    }
  },

  locations(options) {
    this._resetOptions(options);

    this.locationsView = new LocationsView({
      widgetMode: this.widgetMode,
      el: this.el,
    });
  },

  locationsAction(id, action) {
    if (typeof this.locationsView === "undefined") {
      // Only called if coming here via direct link
      this.locations();
    }

    const that = this;

    if (typeof id == "undefined" || _.isNull(id)) {
      that.locationsView.add();
    } else if (action == "edit") {
      that.locationsView.edit(id);
    } else if (action == "remove") {
      that.locationsView.remove(id);
    }
  },

  /**
   * @routes /facilities
   *         /facilities:id -> Highlight & toggle facilities
   */
  facilitiesList(options) {
    //this._resetOptions(options);

    const collection = Radio.channel("facilities").request("get:data").proxy;

    new FacilitiesView({
      collection,
      widgetMode: false,
      el: this.el,
      toggleId: this.options,
    });

    if (!this.widgetMode) {
      (new FacilitiesSidebarView({ collection, model: Facility }).render(),
        new FacilitiesSortTabs({ collection, model: Facility }).render());
    }
  },

  /**
   * @routes /contingents/:id[int]/pricetariffs
   */
  contingentPricetariffsForm(cId) {
    this.index();

    this._collection.fetchById(Number(cId), (model) => {
      if (!(model.get("pricetariffs") instanceof Pricetariffs)) {
        // is array, make collection
        model.set("pricetariffs", new Pricetariffs(model.get("pricetariffs")));
      }

      const pricetariffs = model.get("pricetariffs");

      if (typeof pricetariffs.get("") === "undefined") {
        // Set active contingent as default contingent
        pricetariffs.add({
          contingents: [
            {
              id: model.get("id"),
              name: model.get("name"),
            },
          ],
        });
      }

      const pricetariffForm = new PricetariffForm({
        hasMultiplePricetariffs: true,
        routeBack: "contingents/" + cId,
        collection: pricetariffs,
        contingents: Radio.channel("contingents").request("get:data"),
        pricetypes: Radio.channel("pricetypes").request("get:data"),
        model: pricetariffs.models[0],
      });
    });
  },

  slotsForm(contingentId, action) {
    this.index();

    contingentId = Number(contingentId);

    let model = null,
      contingent = this._collection.get(contingentId);

    if (typeof contingent == "undefined") {
      return;
    }

    if (typeof action == "undefined" || _.isNull(action)) {
      // contingents/:id/resources/add
      model = new Resource({ contingent_id: contingentId });
    } else {
      // contingents/:id/resources/:resourceId
      _.each(contingent.get("resources").models, (resource) => {
        if (resource.get("id") == action) {
          model = resource;
        }
      });

      if (_.isNull(model)) return;
    }

    new SlotsForm({
      el: $(".inb-resource-edit-modal"),
      model: model,
      parent: contingent,
    });
  },
});
